import imagesLoaded from 'imagesloaded'
import client from '@/api/client'
import promoBannerQuery from '@/api/gql/bottom-banner/query/promo-banner.gql'
import PromoBanner from '@/components/_shared/PromoBanner.vue'

export default {
  components: {
    PromoBanner,
  },

  data() {
    return {
      identifier: null,
      images: [],
      headline: null,
      text: null,
      linkUrl: null,
      linkText: null,
      cookieLifetime: null,
      cookieNamePrefix: 'promo_banner',
      loading: true,
      shouldBeVisible: false,
    }
  },

  methods: {
    init(identifier) {
      const referrer = encodeURIComponent(window.location.href)
      this.loading = true

      client
        .query({
          query: promoBannerQuery,
          variables: { referrer, identifier: identifier || this.identifier },
        })
        .then(({ data: { promoBanner } }) => {
          if (promoBanner) {
            Object.assign(this, promoBanner)
            this.displayBanner()
          } else {
            this.loading = false
          }
        })
    },

    displayBanner() {
      this.$nextTick(() => {
        imagesLoaded(this.$refs.wrapper, () => {
          this.shouldBeVisible = true
          this.loading = false
        })
      })
    },

    closeBanner() {
      this.shouldBeVisible = false
      this.writeCookie()

      this.hasBeenClosed = false
      setTimeout(() => (this.hasBeenClosed = true), 1000)
    },

    redirectToLinkUrl(event) {
      if (this.linkUrl && !event.target.matches('.promo-banner__close')) {
        window.location.href = this.linkUrl
      }
    },
  },
}
